module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "titleDiv"
  }, [_c('h2', [_c('strong', [_vm._v("Policy List")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("View your insurance policies here.")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Policy List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "table"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "There is no policy data to display.",
      "data": _vm.policyList
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', [_c('h3', [_c('strong', [_vm._v("Policy Details")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Provider's Name:")]), _vm._v(" " + _vm._s(props.row.providerName))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("PolicyHolder's Name:")]), _vm._v(" " + _vm._s(props.row.policyName))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Policy No.:")]), _vm._v(" " + _vm._s(props.row.policyNumber))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Address on Policy:")]), _vm._v(" " + _vm._s(props.row.policyAddress))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h3', [_c('strong', [_vm._v("Vehicle Details")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("List of Vehicles on Policy:")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((props.row.vehicleList), function(vehicle) {
          return _c('div', [_c('p', [_c('strong', [_vm._v("Vehicle Year:")]), _vm._v(" " + _vm._s(vehicle.yearValue))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Vehicle Make:")]), _vm._v(" " + _vm._s(vehicle.makeValue))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Vehicle Year:")]), _vm._v(" " + _vm._s(vehicle.modelValue))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Vehicle's VIN:")]), _vm._v(" " + _vm._s(vehicle.vinNumber))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("License Plate No.:")]), _vm._v(" " + _vm._s(vehicle.licensePlateNumber))]), _vm._v(" "), _c('hr')])
        })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h3', [_c('strong', [_vm._v("Other Details Noted")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Agent Name:")]), _vm._v(" " + _vm._s(props.row.agentName))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Agent Phone No.:")]), _vm._v(" " + _vm._s(props.row.agentPhone))]), _vm._v(" "), _c('hr')])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Provider Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "bold"
        }, [_c('strong', [_vm._v(_vm._s(scope.row.providerName))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Policy Number",
      "prop": "policyNumber"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Options"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-success",
          on: {
            "click": function($event) {
              return _vm.editPolicy(props.row.policyId)
            }
          }
        }, [_c('span', {
          staticClass: "fa fa-edit"
        }), _vm._v("  Edit Policy")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn btn-danger",
          on: {
            "click": function($event) {
              return _vm.deletePolicy(props.row.policyId)
            }
          }
        }, [_c('span', {
          staticClass: "fa fa-minus-circle"
        }), _vm._v("  Delete Policy")])]
      }
    }])
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/policies/addPolicy"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "40%"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_c('span', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v("  Add New Policy")])], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bd021ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/PolicyList.vue
// module id = 1267
// module chunks = 2